export default {
    name: 'Conciliation',

    props: {
        operation: {
            type: Object,
            required: true
        }
    },

    computed: {
        originEntity() {
            if (!this.operation.reconciliation) {
                return '';
            }
            const entities = [];
            this.operation.reconciliation.transactions.forEach(transaction => {
                if (!entities.includes(transaction.origin_entity)) {
                    entities.push(transaction.origin_entity);
                }
            });
            return entities.join(' | ');
        },

        ibanCode() {
            if (!this.operation.reconciliation) {
                return '';
            }
            const ibanCodes = [];
            this.operation.reconciliation.transactions.forEach(transaction => {
                if (!ibanCodes.includes(transaction.iban_code)) {
                    ibanCodes.push(transaction.iban_code);
                }
            });
            return ibanCodes.join(' | ');
        }
    }
};
